import React, { useState, useEffect, useContext } from 'react'
import { object } from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import { ThemeContext } from 'styled-components'

const Wrapper = styled.div`
  width: 100vw;
  background-color: ${(props) => props.theme.palette.primary.main};
  height: 62px;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 5px rgb(18 23 39 / 50%);
`
const FallbackLogo = styled.a`
  font-family: 'Lato-Bold';
  font-size: 1.35rem;
  text-decoration: none;
  cursor: pointer;
  color: ${(props) => props.theme.palette.onPrimary.main};

  :visited {
    text-decoration: none;
  }
`
const Logo = styled.img`
  height: 100%;
  padding: 5px 0;
`

function Navbar({ company }) {
  const [language, setLanguage] = useState('en')
  const { t, i18n } = useTranslation()
  const changeLanguage = (language) => {
    i18n.changeLanguage(language)
  }

  useEffect(() => changeLanguage(language), [language])

  const themeContext = useContext(ThemeContext)

  return (
    <Wrapper>
      {company.logoUrl ? (
        <Logo src={company.logoUrl} />
      ) : (
        <FallbackLogo href="#">{t('logo')}</FallbackLogo>
      )}
      <div>
        <Button
          variant="text"
          onClick={() => {
            setLanguage(language === 'en' ? 'fr' : 'en')
          }}
          style={{ color: `${themeContext.palette.onPrimary.main}` }}
        >
          {language.toUpperCase()}
        </Button>
      </div>
    </Wrapper>
  )
}

Navbar.propTypes = {
  company: object,
}

export default Navbar
